import React from 'react'

export const EstadoResultadosButton = ({ info, onChange }) => {
    const openModal = () => {
        const element = document.getElementById("box-graficar-container");
        if (element != undefined && element != null)
            element.style.display = "block";
    };
    const closeModal = () => {
        const element = document.getElementById("box-graficar-container");
        if (element != undefined && element != null) element.style.display = "none";
    };

    return (
        <>
            <button className="btn-graficar" onClick={openModal}>
                Agrupar
            </button>

            <div className="box-graficar-container-er" id="box-graficar-container">
                <div className='container-modal-grafica'>
                    <div className="titulo">AGRUPAR POR</div>
                    <span className="close-modal" onClick={closeModal}>
                        x
                    </span>
                    <div className='data-container'>
                        <div className="container">
                            <div class="form-check">
                                <input
                                    class="form-check-input"
                                    type="radio"
                                    name="exampleRadios"
                                    id="adr"
                                    value="option1"
                                    defaultChecked={true}
                                    onChange={() => {
                                        closeModal();
                                        onChange({ ...info, grupo: 'adr' });
                                    }}
                                />
                                <label class="form-check-label" for="adr" >
                                    ADR
                                </label>
                            </div>
                            <div class="form-check">
                                <input
                                    class="form-check-input"
                                    type="radio"
                                    name="exampleRadios"
                                    id="sucursal"
                                    value="option1"
                                    onChange={() => {
                                        closeModal();
                                        onChange({ ...info, grupo: 'sucursal' });
                                    }}
                                />
                                <label class="form-check-label" for="sucursal">
                                    SUCURSALES
                                </label>
                            </div>
                            <div class="form-check">
                                <input
                                    class="form-check-input"
                                    type="radio"
                                    name="exampleRadios"
                                    id="departamento"
                                    value="option1"
                                    onChange={() => {
                                        closeModal();
                                        onChange({ ...info, grupo: 'departamento' });
                                    }}
                                />
                                <label class="form-check-label" for="departamento">
                                    DEPARTAMENTOS
                                </label>
                            </div>
                        </div>
                        <div className="container ml-20">
                            {/* <div class="form-check">
                                <input
                                    class="form-check-input"
                                    type="radio"
                                    name="exampleRadios2"
                                    id="ventasbrutas"
                                    value="option12"
                                    defaultChecked={true}
                                    onChange={() => {
                                        closeModal();
                                        onChange({ ...info, tipo: '1' });
                                    }}
                                />
                                <label class="form-check-label" for="ventasbrutas">
                                    VENTAS BRUTAS
                                </label>
                            </div>
                            <div class="form-check">
                                <input
                                    class="form-check-input"
                                    type="radio"
                                    name="exampleRadios2"
                                    id="rbdescuentos"
                                    value="option12"
                                    onChange={() => {
                                        closeModal();
                                        onChange({ ...info, tipo: '2' });
                                    }}
                                />
                                <label class="form-check-label" for="rbdescuentos">
                                    DESCUENTOS
                                </label>
                            </div> */}
                            <div class="form-check">
                                <input
                                    class="form-check-input"
                                    type="radio"
                                    name="exampleRadios2"
                                    id="rbventasnetas"
                                    value="option12"
                                    onChange={() => {
                                        closeModal();
                                        onChange({ ...info, tipo: '3' });
                                    }}
                                />
                                <label class="form-check-label" for="rbventasnetas">
                                    VENTAS NETAS
                                </label>
                            </div>
                            <div class="form-check">
                                <input
                                    class="form-check-input"
                                    type="radio"
                                    name="exampleRadios2"
                                    id="rbcostodeventa"
                                    value="option12"
                                    onChange={() => {
                                        closeModal();
                                        onChange({ ...info, tipo: '4' });
                                    }}
                                />
                                <label class="form-check-label" for="rbcostodeventa">
                                    COSTOS DE VENTA
                                </label>
                            </div>
                            <div class="form-check">
                                <input
                                    class="form-check-input"
                                    type="radio"
                                    name="exampleRadios2"
                                    id="rbutilidadbruta"
                                    value="option12"
                                    onChange={() => {
                                        closeModal();
                                        onChange({ ...info, tipo: '5' });
                                    }}
                                />
                                <label class="form-check-label" for="rbutilidadbruta">
                                    UTILIDAD BRUTA
                                </label>
                            </div>
                            <div class="form-check">
                                <input
                                    class="form-check-input"
                                    type="radio"
                                    name="exampleRadios2"
                                    id="rbgastosdepartamentos"
                                    value="option12"
                                    onChange={() => {
                                        closeModal();
                                        onChange({ ...info, tipo: '6' });
                                    }}
                                />
                                <label class="form-check-label" for="rbgastosdepartamentos">
                                    GASTOS DEPARTAMENTOS
                                </label>
                            </div>
                            <div class="form-check">
                                <input
                                    class="form-check-input"
                                    type="radio"
                                    name="exampleRadios2"
                                    id="rbutilidadoperacion"
                                    value="option12"
                                    onChange={() => {
                                        closeModal();
                                        onChange({ ...info, tipo: '7' });
                                    }}
                                />
                                <label class="form-check-label" for="rbutilidadoperacion">
                                    UTILIDAD OPERACIÓN
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}
